import { memo } from "react";
import { Undo2, Redo2, Eraser, RotateCcw, Pause, Play, Camera, Download, Save, FileJson, Maximize, Minimize, SlidersHorizontal, Hand, MousePointer2, LayoutGrid } from "lucide-react";

export const Btn = ({ icon: Icon, label, onClick, testid, disabled, on, cls = "" }) => (
  <button className={`tb-btn ${cls} ${on ? "is-on" : ""}`} onClick={onClick} disabled={disabled} data-testid={testid} title={label} aria-label={label}>
    <Icon size={17} strokeWidth={1.7} />
    <span className="tb-label">{label}</span>
  </button>
);

export const BottomToolbar = memo(function BottomToolbar({ a, settings: s, hist, fs, panelOpen }) {
  return (
    <div className="toolbar holo" data-testid="bottom-toolbar">
      <Btn icon={LayoutGrid} label="Lab" onClick={a.lab} testid="button-toolbar-lab" />
      <span className="tb-sep" />
      <Btn icon={s.interact ? MousePointer2 : Hand} label={s.interact ? "Interact" : "Orbit"} onClick={a.interact} testid="button-toggle-interact" on={s.interact} />
      <Btn icon={Undo2} label="Undo" onClick={a.undo} testid="button-undo" disabled={!hist.canUndo} />
      <Btn icon={Redo2} label="Redo" onClick={a.redo} testid="button-redo" disabled={!hist.canRedo} />
      <Btn icon={Eraser} label="Clear" onClick={a.clear} testid="button-clear" />
      <Btn icon={RotateCcw} label="Reset" onClick={a.reset} testid="button-reset" />
      <span className="tb-sep" />
      <Btn icon={s.paused ? Play : Pause} label={s.paused ? "Resume" : "Pause"} onClick={a.pause} testid="button-toggle-pause" on={s.paused} />
      <Btn cls="tb-optional" icon={Camera} label="View" onClick={a.swap} testid="button-swap-perspective" />
      <span className="tb-sep" />
      <Btn icon={Save} label="Save" onClick={a.save} testid="button-save-experiment" />
      <Btn icon={Download} label="PNG" onClick={a.png} testid="button-export-image" />
      <Btn cls="tb-optional" icon={FileJson} label="JSON" onClick={a.json} testid="button-save-json" />
      <Btn cls="tb-optional" icon={fs ? Minimize : Maximize} label="Full" onClick={a.fullscreen} testid="button-toggle-fullscreen" />
      <Btn icon={SlidersHorizontal} label="Settings" onClick={a.panel} testid="button-toggle-panel" on={panelOpen} />
    </div>
  );
});
